import { Injectable, inject } from '@angular/core';
import { calculatePathScore } from '@functions';
import { BoxDetection } from '@models';
import { MetricsService, SimulationService } from '@services';
import { SceneStore } from '@stores';
import { metrics } from './metrics';

@Injectable({
  providedIn: 'root',
})
export class AnatomoMetricsService {
  private metricsService = inject(MetricsService);
  private sceneStore = inject(SceneStore);
  private simulationService = inject(SimulationService);

  metrics = metrics;

  trackLeftTool(tool: BoxDetection) {
    this.metricsService.trackTool(tool, 'leftTool');
  }

  trackRightTool(tool: BoxDetection) {
    this.metricsService.trackTool(tool, 'rightTool');
  }

  finalizeMetrics() {
    this.metrics.time.value = this.simulationService.recordingTime();
    this.metrics.needleDriverLeftPath.value = calculatePathScore({
      maxScore: 25,
      minValue: 580,
      maxValue: 1500,
      value: this.metricsService.getToolDistance('leftTool'),
    });
    this.metrics.needleDriverRightPath.value = calculatePathScore({
      maxScore: 25,
      minValue: 640,
      maxValue: 1500,
      value: this.metricsService.getToolDistance('rightTool'),
    });
  }
}
